<app-alert-modal
  *ngIf="cs.isBrowser"
  #userTypeSelectionModal
  [showConfirmationBtn]="false"
  [showCrossBtn]="true"
  (canceled)="handleCancel()"
  [modalOptions]="{ class: 'modal-md' }"
  dynamicClass="user-type-selection-modal"
>
  <div class="user-type-selection-modal-content d-flex flex-column">
    <div class="welcome-section text-center">
      <h2 class="welcome-title">{{ USER_TYPE_CONSTANTS.WELCOME_TO }}</h2>
      <div class="logo-container d-flex justify-content-center align-items-center mb-4">
        <em class="icon-liteTopfan-logo"></em>
      </div>
    </div>
    
    <div class="button-section d-flex flex-column gap-3">
      <app-button
        [btnField]="{
          label: USER_TYPE_CONSTANTS.I_AM_A_CREATOR,
          class: 'btn btn-primary w-100',
          type: 'button'
        }"
        (handleButtonClick)="navigateToCreatorHome()"
      ></app-button>

      <app-button
        [btnField]="{
          label: USER_TYPE_CONSTANTS.I_AM_A_FAN,
          class: 'btn btn-primary w-100',
          type: 'button'
        }"
        (handleButtonClick)="navigateToFanSignup()"
      ></app-button>
    </div>
  </div>
</app-alert-modal>
